import React, { useCallback } from "react";
import { UploadIcon } from "@heroicons/react/outline";
import { CloudUpload } from "@mui/icons-material";

type Props = {
  iconSrc?: string;
  imageSrc?: string;
  onSelectImage?: () => void;
  onSelectIcon?: () => void;
};

const ImageSelector = React.memo(
  ({ imageSrc, iconSrc, onSelectImage, onSelectIcon }: Props) => {
    const onIconClick = useCallback(
      (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        event.stopPropagation();
        onSelectIcon && onSelectIcon();
      },
      [onSelectIcon]
    );

    return (
      <div className="flex gap-8 relative">

        <div
          className="flex flex-col h-96 flex-1 items-center justify-center bg-gray-400 border-dashed border-gray-50 border rounded-xl bg-kyzzen-secondary bg-full cursor-pointer"
          role="button"
          onClick={onSelectImage}
        >
          {imageSrc ? (
            <img alt={`banner ${imageSrc}`} src={imageSrc} className="h-96" />
          ) : (
            <div className="flex flex-1  flex flex-col items-center justify-center">
              {!imageSrc && (
                <div className="flex flex-col items-center w-full">
                  <div className="rounded-full p-3 mb-2 block bg-gray-80">
                    <span className="rounded-full p-2 block bg-gray-60">
                      <CloudUpload className="h-12 w-12 text-gray-50" />
                    </span>
                  </div>
                  <span className="text-sm text-gray-30">
                    <span className="text-blue">Upload a Banner</span> (PNG/JPG)
                  </span>
                  <span className="text-sm text-gray-30 ">
                    Recommended resolution 640 x 360
                  </span>
                </div>
              )}
            </div>
          )}
        </div>
        <div
          className="w-56 h-56 flex flex-col items-center justify-center cursor-pointer border-dashed border-gray-50 border rounded-xl bg-kyzzen-secondary rounded-md bg-gray-400 bg-full"
          role="button"
          style={{
            backgroundImage: `url(${iconSrc})`,
            backgroundPosition: `center`,
            backgroundSize: `cover`
          }}
          onClick={onIconClick}
        >
          {!iconSrc && (
            <div className="flex flex-col items-center">
              <div className="rounded-full p-2 mb-2 block bg-gray-80">
                <span className="rounded-full p-1 block bg-gray-60">
                  <CloudUpload className="h-8 w-8 text-gray-50" />
                </span>
              </div>
              <div className="px-4 text-center">
              <span className="text-sm text-gray-30 block">
                <span className="text-blue">Upload a Logo</span> 
              </span>
              <span className="block text-sm">
              (PNG/JPG)
              </span>
              <span className="text-sm text-gray-30 ">
                Recommended resolution 240 x 260
              </span>
              </div>
              
            </div>
          )}
        </div>
      </div>
    );
  }
);

export default ImageSelector;
